export default __webpack_public_path__ + "static/media/marker.cb9b927e.svg";